export default __webpack_public_path__ + "static/media/security.3536fd02.svg";